module.exports = __webpack_public_path__ + "static/feature-d528edfe42252a0449b7feb0fcecf470.png";